import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/api';
import { 
  FaInbox, FaFileInvoice, 
  FaChartLine, FaUsers, FaFileAlt, FaUser, FaChevronDown 
} from 'react-icons/fa';
import beReliableLogo from "../../assets/logo/bereliable-logo.png";
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [stats, setStats] = useState({
    totalInquiries: 0,
    totalQuotations: 0,
    recentInquiries: 0
  });
  const [loading, setLoading] = useState(true);
  const dropdownRef = useRef(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [inquiriesRes, quotationsRes] = await Promise.all([
        axios.get('/inquiries/all'),
        axios.get('/quotation/all')
      ]);

      const recentDate = new Date();
      recentDate.setDate(recentDate.getDate() - 7);
      const recentInquiries = inquiriesRes.data.data.filter(
        inv => new Date(inv.timestamp) >= recentDate
      ).length;

      setStats({
        totalInquiries: inquiriesRes.data.count || 0,
        totalQuotations: quotationsRes.data.count || 0,
        recentInquiries
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div className="admin-header-left">
          <img src={beReliableLogo} className="admin-header-logo" />
        </div>
        <div className="admin-header-right">
          <h1>Admin Dashboard</h1>
          <div className="admin-profile-dropdown" ref={dropdownRef}>
            <button
              type="button"
              className="profile-trigger"
              onClick={() => setIsDropdownOpen((prev) => !prev)}
            >
              <FaUser className="profile-icon" />
              <span className="profile-name">Welcome back, admin</span>
              <FaChevronDown className="profile-arrow" />
            </button>
            {isDropdownOpen && (
              <div className="profile-menu">
                <button
                  type="button"
                  className="profile-menu-item"
                  onClick={() => {
                    setIsDropdownOpen(false);
                    navigate('/admin/change-password');
                  }}
                >
                  Change Password
                </button>
                <button
                  type="button"
                  className="profile-menu-item"
                  onClick={() => {
                    setIsDropdownOpen(false);
                    handleLogout();
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="admin-content">
        <div className="container">
          {loading ? (
            <div className="spinner"></div>
          ) : (
            <>
              <div className="stats-grid">
                <div className="stat-card card">
                  <div className="stat-icon">
                    <FaInbox />
                  </div>
                  <div className="stat-info">
                    <h3>{stats.totalInquiries}</h3>
                    <p>Total Inquiries</p>
                  </div>
                </div>

                <div className="stat-card card">
                  <div className="stat-icon">
                    <FaFileInvoice />
                  </div>
                  <div className="stat-info">
                    <h3>{stats.totalQuotations}</h3>
                    <p>Total Quotations</p>
                  </div>
                </div>

                <div className="stat-card card">
                  <div className="stat-icon">
                    <FaChartLine />
                  </div>
                  <div className="stat-info">
                    <h3>{stats.recentInquiries}</h3>
                    <p>Recent Inquiries (7 days)</p>
                  </div>
                </div>
              </div>

              <div className="dashboard-modules">
                <Link to="/admin/inquiries" className="module-card card">
                  <FaInbox className="module-icon" />
                  <h2>Inquiries Dashboard</h2>
                  <p>View and manage all customer inquiries</p>
                  <span className="module-count">{stats.totalInquiries} inquiries</span>
                </Link>

                <Link to="/admin/quotation-builder" className="module-card card">
                  <FaFileInvoice className="module-icon" />
                  <h2>Quotation Builder</h2>
                  <p>Create motor insurance quotations</p>
                  <span className="module-count">Start Quotation</span>
                </Link>

                <Link to="/admin/quotation-history" className="module-card card">
                  <FaFileAlt className="module-icon" />
                  <h2>Quotation History</h2>
                  <p>View and manage quotation history</p>
                  <span className="module-count">{stats.totalQuotations} quotations</span>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;


